export default {
  setChatUrl: (state, url) => {
    state.chatUrl = url;
  },
  setCrmTemplates: (state, templates) => {
    state.crmTemplates = templates;
  }
};
